var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex align-center justify-space-between w-100" },
    [
      _c("div", { staticClass: "d-flex align-center" }, [
        _c("h3", { staticClass: "mb-0 font-weight-medium" }, [
          _vm.currentSection
            ? _c("span", [
                _vm._v(
                  "Showing " +
                    _vm._s(_vm.currentSection) +
                    " of " +
                    _vm._s(_vm.totalSectionCount) +
                    " sections"
                ),
              ])
            : _c("span", [_vm._v(_vm._s(_vm.totalSectionCount) + " sections")]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "ml-2 text--secondary" }, [
          _vm._v("(" + _vm._s(_vm.totalNotes) + " notes)"),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }